import React from 'react';
import { Radio, FormControlLabel } from '@mui/material';
import theme from 'theme/ThemeContext';

const CustomRadio = ({ label, sx, ...props }) => {
  return (
    <FormControlLabel
      control={
        <Radio
          {...props}
          sx={{
            // color: theme.palette.primary.main,
            '&.Mui-checked': {
              color: theme.palette.primary.main || theme.palette.primary.main,
            },
            ...sx,
          }}
        />
      }
      label={label}
    />
  );
};

export default CustomRadio;
